export default class DocumentSearchCriteria {
    expiresBefore: string;
    entityType: number;
}